import { render } from "./TestAdmin.vue?vue&type=template&id=15f83078&scoped=true"
import script from "./TestAdmin.vue?vue&type=script&lang=js"
export * from "./TestAdmin.vue?vue&type=script&lang=js"

import "./TestAdmin.vue?vue&type=style&index=0&id=15f83078&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f83078"]])

export default __exports__